import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useMe } from '../organisation/useMe';
import { scenarioInternalApi, scenarioMetricsApi } from '../apis';
import { FindScenarioMetricsPeriodTypeEnum, InternalApiScenario, InternalApiUpdateScenario } from '../api-internal';

export const SCENARIO_QUERY_KEY = 'scenario';
export const SCENARIO_METRICS_QUERY_KEY = 'scenario_metrics';

export const useQueryScenario = (id: string) => {
  const { currentOrganisation } = useMe();

  return useQuery({
    queryKey: [SCENARIO_QUERY_KEY, id, currentOrganisation?.id],
    queryFn: async () => await scenarioInternalApi.getScenario({ scenarioHandle: id }),
  });
};

export const useQueryScenarioMetrics = (id: string, periodType: FindScenarioMetricsPeriodTypeEnum) => {
  const { currentOrganisation } = useMe();

  return useQuery({
    queryKey: [SCENARIO_METRICS_QUERY_KEY, id, currentOrganisation?.id, periodType],
    queryFn: async () => await scenarioMetricsApi.findScenarioMetrics({ scenarioHandle: id, periodType }),
  });
};

export const useUpdateScenario = () => {
  const queryClient = useQueryClient();
  const { currentOrganisation } = useMe();

  return useMutation({
    mutationFn: ({
      id,
      internalApiUpdateScenario,
    }: {
      id: string;
      internalApiUpdateScenario: InternalApiUpdateScenario;
    }) => {
      return scenarioInternalApi.updateScenario({
        scenarioHandle: id,
        internalApiUpdateScenario,
      });
    },
    onSuccess: (scenario: InternalApiScenario) => {
      queryClient.setQueryData([SCENARIO_QUERY_KEY, scenario.id, currentOrganisation?.id], scenario);
    },
  });
};

export const useQueryScenarioCategories = () => {
  return useQuery({
    queryKey: ['categories'],
    queryFn: async () => {
      return await scenarioInternalApi.findAllScenarioCategories();
    },
    initialData: [],
  });
};

export const useQueryScenarioTypologies = (categoryId?: string) => {
  return useQuery({
    queryKey: ['typologies', categoryId],
    queryFn: async () => {
      if (categoryId) {
        return await scenarioInternalApi.findAllScenarioTypologies({ categoryId });
      }
      return [];
    },
    initialData: [],
  });
};
